import { useTranslation } from 'react-i18next';
import { TooltipChartData } from './types';

type Props = {
  active?: boolean;
  payload?: Array<{
    payload: TooltipChartData;
  }>;
};

export const CustomTooltip = ({ active, payload }: Props) => {
  const { t } = useTranslation();

  if (!active || !payload?.length) return null;

  const {
    name,
    rawValue,
    prefix,
    suffix,
    benchmarkMax,
    showBenchmark,
    showPrevious,
    tooltipPreviousCopy,
    previous,
    previousRaw,
  } = payload[0].payload;

  const previousText =
    previousRaw === null
      ? 'N/A'
      : previousRaw
        ? `${prefix}${previousRaw}${suffix}`
        : `${prefix}${previous}${suffix}`;

  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid #ddd',
        padding: '8px 12px',
        borderRadius: 6,
        fontSize: 12,
      }}
    >
      <div>
        <b>{name}</b>: {`${prefix}${rawValue}${suffix}`}
      </div>
      {showPrevious && (
        <div>
          <b>{tooltipPreviousCopy || t('dashboard.previous')}</b>: {previousText}
        </div>
      )}
      {showBenchmark && (
        <div>
          <b>{t('dashboard.benchmark')}</b>: {`${prefix}${benchmarkMax}${suffix}`}
        </div>
      )}
    </div>
  );
};
